import { AxiosError } from 'axios'
import { flow, makeObservable } from 'mobx'

import { STORE_UI } from 'Core/constants'
import { searchQueryConfig } from 'Core/constants/filters'
import { CoreUrlParams, SortingParams } from 'Core/interfaces'
import { TableStore } from 'Core/stores/tableStore/TableStore'

import { UrlParams } from 'Portals/Customer/constants'
import { Report } from 'Portals/Customer/entities'
import {
	getFilterConfig,
	getMainSearchConfig
} from 'Portals/Customer/Pages/Report/TableList/Filters/utils/config'
import { ReportRepo } from 'Portals/Customer/repositories'
import { RootStore } from 'Portals/Customer/stores'

const STORAGE_REPORT_PAGE_SIZE = 'is2/reportPageSize'

export class ReportTable extends TableStore<Report.Basic> {
	constructor(public rootStore: RootStore) {
		super(STORAGE_REPORT_PAGE_SIZE)
	}

	@flow.bound
	*getItems(defaultSort?: SortingParams) {
		try {
			yield this.requestData({
				defaultSort,
				repository: ReportRepo.getList
			})
		} catch (error) {
			this.rootStore[STORE_UI].showErrorNotification(error as AxiosError)
		}
	}

	initFromURLParams = (params: Record<string, string[]>) => {
		const searchKeys = [UrlParams.reportName, CoreUrlParams.searchQuery]

		const filterKeys = [UrlParams.startDate, UrlParams.endDate, UrlParams.statusId]

		const mergedSearchConfig = {
			...getMainSearchConfig(),
			...searchQueryConfig
		}

		this.initSearchParamsFromUrl(params, searchKeys, mergedSearchConfig)
		this.initFilterParamsFromUrl(params, filterKeys, getFilterConfig())
	}
}
